/// <amd-module name="Widgets/CumulativeFlowDiagram/CumulativeFlowDiagramContracts" />
import { Theme } from "./ChartColorPalettes";

export interface CumulativeFlowDiagramSettings {
    chartDataSettings: CumulativeFlowHistoryOptions;
    themeName: Theme;
}

/** The options used for retrieving CFD chart data */
export interface CumulativeFlowHistoryOptions {
    /** The name or ID of a project */
    project: string;

    /** The name or ID of a team within the given project */
    team: string;

    /** The ID of a board within the given team within the given project */
    board: string;

    /**
     * (Optional)
     * The name of a swimlane on a board.
     * A value of null or undefined means don't filter on lane.
     */
    boardLane?: string | null;

    /**
     * Contains settings related to defining a time period.
     * The settings are associated with a particular identifier to identify the kind of settings stored.
     *
     * Identifiers: RollingPeriod, StartDate
     *
     * RollingPeriod (Type: number)
     *     Defines a rolling time period prior to today for the CFD
     *
     * StartDate (Type: string)
     *     A date string (yyyy-MM-dd) defining the range of dates to show on the CFD
     *     from the start date to today.
     */
    timePeriod: RollingTimePeriod | StartDateTimePeriod;

    /** Whether or not to include the first Kanban column in the CFD chart */
    includeFirstBoardColumn: boolean;

    /** Fine grained set of board columns requested by the user.
     *  Note: This option not currently supported as part of the Widget Configuration Experience.
     *  Only available through the CFD Report UI.
     */
    desiredBoardColumnIds?: string[];
}

export interface StartDateTimePeriod {
    identifier: "StartDate";
    settings: string;
}

export interface RollingTimePeriod {
    identifier: "RollingPeriod";
    settings: number;
}
